import Navbar from "../components/Navbar";
import space from '../assets/Space.mp4';
import '../css/home.css';
import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import Landing from "../components/Landing";
import Funds from "../components/Funds";
import BackToTop from "../components/BackToTop";
import Client from "../components/Client";
import slider1 from "../assets/slider/7.png"
import slider2 from "../assets/slider/6.png"
import slider3 from "../assets/slider/5.png"
import slider4 from "../assets/slider/8.png"
import MottoBar from "../components/MottoBar";
import LatestWork from "../components/LatestWork";

export default function Home() {
    return (
        <>
           {/* <MottoBar /> */}
            <Navbar />
            {/* <div className="video-container">
                <video src={space} type="video/mp4" autoPlay loop muted>
                    Sorry, your browser doesn't support videos.
                </video>
                <div className="typewriter">
                    <h2>Our Motto: “नर सेवा, नारायण सेवा”... </h2>
                </div>
            </div> */}

            <div id="heroCarousel" className="carousel slide hero-slider" data-bs-ride="carousel" data-bs-interval="2500"  data-bs-pause="false">
    
    <div className="carousel-inner">
        <div className="carousel-item active">
            <img src={slider1} className="d-block w-100" alt="Slide 1" />
        </div>

        <div className="carousel-item">
            <img src={slider2} className="d-block w-100" alt="Slide 2" />
        </div>

        <div className="carousel-item">
            <img src={slider3} className="d-block w-100" alt="Slide 3" />
        </div>
         <div className="carousel-item">
            <img src={slider4} className="d-block w-100" alt="Slide 4" />
        </div>
    </div>

    {/* Optional Controls */}
    <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon"></span>
    </button>

    <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon"></span>
    </button>

    {/* Motto Overlay */}
    {/* <div className="hero-overlay">
        <h2>Our Motto: “नर सेवा, नारायण सेवा”</h2>
    </div> */}
</div>
            <Landing />
            <Initiatives />
            <Client/>
            <Funds />
            <LatestWork/>
            <ContactForm />
            <Footer />
            <BackToTop />
        </>
    );
}